export interface GetWorkflowStateResponse {
    workflowState: WorkflowStateModel;
    entityType: string;
    canTakeOwnership: boolean;
    canReassign: boolean;
}

export interface WorkflowStateModel {
    workflowStateId: number;
    entityId: number;
    entityTypeId: number;
    state: number;
    workflowAssignments: WorkflowAssignmentModel[];
    workflowCancellationReasonId: number;
    workflowMeta: string;
    name: string;
    workflowStatusNotes?: string;
    workflowCancellationNotes?: string;
}

export interface WorkflowAssignmentModel {
    workflowAssignmentId
    actionTakerId: number;
    actionTaker: string;
    isAccepted: boolean;
    isCurrentAssignment: boolean;
    reasonId: number;
    remarks: string;
    meta: string;
    configMeta: string;
    creationDate: string;
    lastModified: string;
    closedDate: string;
    actionTakerDepartmentId: number;
    actionTakerBranchId?: number;
    actionTakerDepartment: string;
    stepNumber: number;
    workflowState: WorkflowStateModel;
    workflowStateId: number;
    internalName: string;
    assignmentState: AssignmentStateModel;
}

export interface AssignmentStateModel {
    showUserAndDepartment: boolean;
    showStatus: boolean;
    isSystemAssignment: boolean;
    actionTakerAnonText: string;
    classList: string;
}

export enum FormsStatusEnum {
    ComputingRules = "Computing Rules",
    PendingFormInput = "Pending Form Input",
    PendingReview = "Pending Terminal/RS Review",
    Accepted = "Accepted",
    Unacceptable = "Unacceptable",
    Cancelled = "Cancelled",
    RequestingInfo = "Requesting Info",
    AcceptableDayOnly = "Acceptable Day Only",
    Completed = "Completed"
}

export enum FormTypesEnum {
    ChangeOfManagement = 20,
    ClassStatusReport = 26
}

export interface GetOnboardingRequestResponse {
    onboardingRequest: OnboardingRequestModel;
    entityTypeId: number;
    onboardingCustomContentPath: string;
    onboardingHeaderPath: string;
    onboardingAfterBasicMetaPath: string;
    onboardingRequestsPath: string;
    pluginName: string;
}

export interface OnboardingRequestModel {
    onboardingRequestId: number;
    landingPage: number;
    onboardingConfig: OnboardingConfigModel;
    offeringsMeta: string;
    onboardingRequestGuid?: string;
    urlsHistoryJson: string;
    modelMeta: string;
    clientNotes: string;
    isCompleted: boolean;
    rejectionReason?: string;
    isRejected?: boolean;
}

export interface OnboardingConfigModel {
    onboardingConfigId: number;
    name: string;
    guid: string;
    isActive: boolean;
    isSelectable: boolean;
    basicMetaConfig: string;
    advancedMetaConfig: string;
    offeringsMetaConfig: string;
    pluginMetaConfig: string;
    isBasicMetaFormStyle: boolean;
    isAdvancedMetaFormStyle: boolean;
    landingPages: OnboardingConfigLandingPageModel[];
    sections: string[];
    workflowConfigurationId: number;
    onboardingPluginId: number;
    termsAndConditions: string;
    isGeoLocationEnabled: boolean;
    navigationHandler: string;
    doNotUseFallback: boolean;
    isGdprConsentEnabled: boolean;
    rulesScript: string;
    rulesScriptLanguage: string;
    onboardingCategoryId?: number;
    onboardingPluginEntityTypeId?: number;
    onboardingVersionCategoryId?: number;
}

export interface OnboardingConfigLandingPageModel {
    onboardingConfigLandingPageId: number;
    onboardingConfigId: number;
    landingPage: string;
    completeRequestLandingPage: string;
    guid: string;
}

export interface GetOnboardingConfigResponse {
    onboardingConfig: OnboardingConfigModel;
    landingPages: OnboardingLandingPage[];
    sections: string[];
    offeringConfigMetaPath: string;
    pluginConfigMetaPath: string;
}

export interface OnboardingLandingPage {
    name: string;
    completeOnboardingPages: string[];
}